import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["personality-button", [_ctx.type, _ctx.disabled && 'is-disabled', { loading: _ctx.loading }]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['personality-button-container',{ loading: _ctx.loading }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickHandler && _ctx.clickHandler(...args)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(['p-button-text',_ctx.colorText])
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_loading, {
              key: 0,
              iconName: "common-icon-loadingH"
            }))
          : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true)
      ], 2)
    ], 2)
  ], 2))
}